import { Cloud, Droplets, Wind } from 'lucide-react';

const WeatherTicker = ({ weather }) => {
  if (!weather) return null;

  return (
    <div className="weather-ticker" data-testid="weather-ticker">
      <div className="ticker-content">
        <div className="weather-item">
          <Cloud size={24} />
          <span className="weather-temp">{Math.round(weather.temperature)}°C</span>
          <span className="weather-desc">{weather.description}</span>
        </div>
        
        <div className="weather-divider">•</div>
        
        <div className="weather-item">
          <span>Feels like: {Math.round(weather.feels_like)}°C</span>
        </div>
        
        <div className="weather-divider">•</div>
        
        <div className="weather-item">
          <Droplets size={18} />
          <span>{weather.humidity}%</span>
        </div>
        
        <div className="weather-divider">•</div>
        
        <div className="weather-item">
          <Wind size={18} />
          <span>{weather.wind_speed} m/s</span>
        </div>
        
        <div className="weather-divider">•</div>
        
        <div className="weather-item">
          <span className="weather-location">King's Lynn</span>
        </div>
      </div>
    </div>
  );
};

export default WeatherTicker;